import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import { Trans } from 'react-i18next';
import { ConfigContext } from '../../../context';
import { translate } from '../../../strings/i18n';
import { FAS_CIRCLE_EXCLAMATION } from '../../../../../const/icon-props';
import { OnlineChatButton } from './subcomponents';
import StatusMessage from '../StatusMessageBox';
const MaximumMessageBox = () => {
    const { pointOfNeedChat } = useIVASetChatStatus();
    const { selectedAccountId } = useContext(ConfigContext);
    const onlineChatText = translate('maximumMessageBox.onlineChat');
    const handleIVAChat = () => {
        pointOfNeedChat('MC', selectedAccountId);
    };
    const onlineChatLink = (_jsx(OnlineChatButton, { buttonType: "text", "data-type": "online chat", "data-analytics": "clicktrackingevent", onClick: handleIVAChat, children: onlineChatText }));
    return (_jsx(StatusMessage, { type: "warning", iconTitle: "exclamation circle icon", icon: FAS_CIRCLE_EXCLAMATION, messageTitle: translate('maximumMessageBox.title'), messageDescription: _jsxs(_Fragment, { children: [_jsx(Trans, { i18nKey: "addAnotherAuthorizedUser", value: onlineChatLink, components: { onlineChatLink }, children: translate('maximumMessageBox.addAnotherAuthorizedUser', {
                        onlineChatText
                    }) }), "."] }) }));
};
export default MaximumMessageBox;
